<template>
    <div class="parkingDetailBox">

      <!-- calc(100vh - 100px) -->
      <div style="min-height:100vh;">
        <van-nav-bar title="收款明细" fixed left-arrow @click-left="returnPage" />
        <div class="parkingDetailBox_header">
          <h2 @click="selectDate">
            {{currentDate}}
            <span></span>
          </h2>
          <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item
              v-model="queryInfo.tradingType"
              @change="typechange"
              :options="tradingTypeList"
            />
          </van-dropdown-menu>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="refreshBox1">
          <div class="parkingDetailBox_body" v-for="(item,index) in listData" :key="index">
            <div class="parkingDetailBox_body_t">
              <h2>{{item.confirmDateType}}</h2>
              <h3>
                收入
                <span>¥{{extraParams[item.confirmDateType]}}</span>
              </h3>
            </div>
            <div class="parkingDetailBox_body_b" v-for="(it,idx) in item.list" :key="idx">
              <div>
                <h1>{{it.roadName}}</h1>
                <h2>+{{it.paymentTotal}}</h2>
              </div>
              <div>
                <h3>{{it.confirmDate}}</h3>
                <h4>{{it.tradingTypeName}}</h4>
              </div>
            </div>
          </div>

          <p @click="loadMore" v-if="noMore" class="loadMore">
            <van-icon name="arrow-up" />点击加载更多
          </p>
        </van-pull-refresh>
      </div>

      <van-popup v-model="Dateshow" round position="bottom" :style="{ height: dataHeight}">
        <div class="poputHeader">
          <h2 @click="Dateshow = false">取消</h2>
          <div>
            <h2
              style="margin-right: 58px;"
              :class="queryInfo.type == 2 ? 'fontColor' :''"
              @click="switchDate(2)"
            >选择月份</h2>
            <h2 :class="queryInfo.type == 3 ? 'fontColor' :''" @click="switchDate(3)">自定义</h2>
          </div>

          <h3 style="color:#208FFF" @click="selectSave">确定</h3>
        </div>

        <div v-if="queryInfo.type == 2" class="poputBody_1">
          <van-datetime-picker
            v-model="datetest"
            type="year-month"
            title="选择年月"
            :formatter="formatter"
          />
        </div>
        <div v-if="queryInfo.type == 3" class="poputBody_2">
          <div class="poputBody_2_h">
            <h2 class="poputBody_2_h_t">交易时间</h2>
            <div @click="dateProxy($event)">
              <h1
                v-for="(item,index) in dateSection"
                :key="index"
                :data-index="index"
                :class="[active == index ?'selected':'']"
              >{{item}}</h1>
            </div>
          </div>
          <div class="poputBody_2_h" style="padding-top:25px;position: relative;
      z-index: 10;background: #fff;padding-bottom:10px">
            <h2 class="poputBody_2_h_t">自定义</h2>
            <p>
              <input
                type="text"
                v-model="startTime"
                readonly
                @focus="dateInputFocus('start')"
                @blur="onBlur"
              />
              <span></span>
              <input
                @focus="dateInputFocus('end')"
                type="text"
                v-model="endTime"
                readonly
                @blur="onBlur"
              />
            </p>
          </div>
          <div class="poputBody_2_h_b" v-if="seleteDateShow">
            <van-datetime-picker
              v-if="seleteDateShow"
              v-model="datetest"
              type="date"
              title="选择年月"
              :formatter="dateformatter"
              @change="customDateChange"
            />
          </div>
          <p>查询日期跨度最多为6个月</p>
        </div>
      </van-popup>
    </div>
  </template>

  <script>
  import DetailDialog from "./components/detailDialog"
  import moment from "moment"
  export default {
    components: {
      DetailDialog
    },
    data() {
      return {
        queryInfo: {
          deptId: localStorage.getItem("vde"),
          tradingType: "",
          type: "2", //1年2月3日期
          startTime: "",
          endTime: "",
          page: "",
          limit: ""
        },
        finishedText: "没有更多数据了",
        loading: false,
        finished: false,
        refreshing: false,
        listData: [],
        total: 0,
        row: {},
        payTotal: "",
        isShowDetail: false,
        tradingTypeList: [],
        currentDate: moment().format("YYYY-MM"),
        isLoading: false,
        oldArr: [],
        noMore: true,
        extraParams: {},
        Dateshow: false,
        datetest: new Date(),
        dataHeight: "30%",
        dateSection: ["近一个月", "近三个月", "近半年"],
        active: null,
        seleteDateShow: false,
        seleteDateType: ""
      }
    },
    computed:{
      startTime(){
        if(this.queryInfo.startTime){
          return moment(this.queryInfo.startTime).format("YYYY年MM月DD日")
        } else{
          return ''
        }
      },
      endTime(){
          if(this.queryInfo.endTime){
           return  moment(this.queryInfo.endTime).format("YYYY年MM月DD日")
        } else{
          return ''
        }

      },
    },
    created() {
      this.queryInfo = this.$route.query.queryInfo?JSON.parse(this.$route.query.queryInfo):'';
      this.queryInfo.limit = 10
      this.queryInfo.page = 1
      this.getTradingType()
      this.$set(this.queryInfo,'startTime',this.queryInfo.sConfirmDate);
      this.$set(this.queryInfo,'endTime',this.queryInfo.eConfirmDate);
      // this.$set(this.queryInfo,'startTime', moment(this.queryInfo.sConfirmDate).startOf("month").format("YYYY-MM-DD"));
      // this.$set(this.queryInfo,'endTime',moment(this.queryInfo.eConfirmDate).endOf("month").format("YYYY-MM-DD"));
      if(this.queryInfo.type=='3'){
          this.currentDate = `${this.queryInfo.sConfirmDate}-${this.queryInfo.eConfirmDate}`
      }
      delete this.queryInfo.eConfirmDate;
      delete this.queryInfo.sConfirmDate;
    //   this.queryInfo.startTime =
    //   this.queryInfo.endTime = moment().endOf("month").format("YYYY-MM-DD")
      this.getDetailData()
    },
    methods: {
      dateInputFocus(str) {
        this.seleteDateShow = true
        this.seleteDateType = str
        this.dataHeight = "65%"
        this.active = null
        if (str == "start") {
          this.datetest = moment(this.queryInfo.startTime).toDate()
        } else {
          this.datetest = moment(this.queryInfo.endTime).toDate()
        }
      },
      customDateChange() {
        if (this.seleteDateType == "start") {
          this.queryInfo.startTime = moment(this.datetest).format("YYYY-MM-DD")
        } else {
          this.queryInfo.endTime = moment(this.datetest).format("YYYY-MM-DD")
        }
      },
      dateProxy(event) {
        const index = event.target.getAttribute("data-index")
        this.active = index
        this.seleteDateShow = false
        this.dataHeight = "40%"
        if (index == 0) {
          this.queryInfo.startTime = moment(new Date())
            .subtract(1, "months")
            .format("YYYY-MM-DD")
          this.queryInfo.endTime = moment().format("YYYY-MM-DD")
        } else if (index == 1) {
          this.queryInfo.startTime = moment(new Date())
            .subtract(3, "months")
            .format("YYYY-MM-DD")
          this.queryInfo.endTime = moment().format("YYYY-MM-DD")
        } else {
          this.queryInfo.startTime = moment(new Date())
            .subtract(6, "months")
            .format("YYYY-MM-DD")
          this.queryInfo.endTime = moment().format("YYYY-MM-DD")
        }
      },
      onBlur() {
        this.seleteDateShow = false
        this.dataHeight = "40%"
      },
      selectSave() {
        if (this.queryInfo.type == 2) {
          // console.log(moment(this.currentDate).toString())
          this.queryInfo.startTime = moment(this.datetest)
            .startOf("month")
            .format("YYYY-MM-DD")
          this.queryInfo.endTime = moment(this.datetest)
            .endOf("month")
            .format("YYYY-MM-DD")
          this.currentDate = moment(this.datetest).format("YYYY-MM")
          this.Dateshow = false
          this.initList()
          this.getDetailData()
        } else {
          if (this.queryInfo.endTime == "" || this.queryInfo.startTime == "") {
            this.$CDialog({
              confirmBtnText: "确认",
              title: "错误提示",
              message: "开始时间或结束时间不能为空",
              status: "2",
              textSize: "14"
            })
            return
          }
          if (
            moment(this.queryInfo.endTime).diff(
              moment(this.queryInfo.startTime),
              "months"
            ) > 6
          ) {
            this.$CDialog({
              confirmBtnText: "确认",
              title: "错误提示",
              message: "查询日期跨度最多为6个月",
              status: "2",
              textSize: "16"
            })
            return
          }
          if (moment(this.queryInfo.endTime).isBefore(this.queryInfo.startTime)) {
            this.$CDialog({
              confirmBtnText: "确认",
              title: "错误提示",
              message: "结束日期不能小于开始日期",
              status: "2",
              textSize: "14"
            })
            return
          }
          this.currentDate = `${this.queryInfo.startTime}-${this.queryInfo.endTime}`
          this.Dateshow = false
          this.initList()
          this.getDetailData()
        }
      },
      dateformatter(type, val) {
        if (type === "year") {
          return `${val}年`
        } else if (type === "month") {
          return `${val}月`
        } else if (type === "day") {
          return `${val}日`
        }
        return val
      },
      formatter(type, val) {
        if (type === "year") {
          return `${val}年`
        } else if (type === "month") {
          return `${val}月`
        }
        return val
      },
      switchDate(num) {
        this.queryInfo.type = num
        this.queryInfo.startTime = ""
        this.queryInfo.endTime = ""
        if (num == 2) {
          this.dataHeight = "40%"
          this.active = null
        } else {
          this.dataHeight = "40%"
        }
      },
      selectDate() {
        this.Dateshow = true
        this.queryInfo.type = "2"
        this.dataHeight = "40%"
        this.datetest = moment().toDate()
      },
      typechange(value) {
        this.queryInfo.tradingType = value
        this.queryInfo.page = 1
        this.initList()
        this.getDetailData()
      },
      loadMore() {
        this.queryInfo.page++
        this.getDetailData()
      },
      onRefresh() {
        this.queryInfo.page = 1
        this.noMore = true
        this.extraParams = {}
        this.oldArr = []
        this.queryInfo.tradingType = ""
        this.getDetailData()
      },
      // 获取缴费方式
      getTradingType() {
        this.request({
          url: "/sysPayWay/geAll",
          method: "get"
        }).then((res) => {
          if (res.data.code == 1000) {
            this.tradingTypeList = res.data.result
            this.tradingTypeList.map((item) => {
              item.text = item.label
            })
            this.tradingTypeList.unshift({ text: "全部", value: "" })
          }
        })
      },
      formatData(arr, group_key = "confirmDateType") {
        // 先定义一个空对象和空数组；
        let map = {}
        let res = []
        for (let i = 0; i < arr.length; i++) {
          let ai = arr[i]
          if (!map[ai[group_key]]) {
            map[ai[group_key]] = [ai]
          } else {
            map[ai[group_key]].push(ai)
          }
        }
        Object.keys(map).forEach((key) => {
          res.push({
            [group_key]: key,
            list: map[key]
          })
        })
        return res
      },

      initList() {
        this.extraParams = {}
        this.oldArr = []
        this.listData = []
        this.noMore = true
      },
      getDetailData() {
        this.request({
          url: "/report/sideParkingPayDetailNoAuth",
          method: "get",
          params: this.queryInfo
        }).then((res) => {
          if (res.data.code == 1000) {
            this.isLoading = false
            if (res.data.result.total == 0) {
              this.listData = []
              this.noMore = false
              this.oldArr = []
            } else {
              if (this.oldArr.length < res.data.result.total) {
                if (res.data.result.list) {
                  this.extraParams = res.data.result.extraParams
                  this.oldArr.push(...res.data.result.list)
                  this.listData = this.formatData(this.oldArr)
                }
              } else {
                this.noMore = false
              }
            }
          } else {
            this.finished = true
          }
        })
      },
      returnPage() {
        this.$router.go(-1)
      },

      getDetailRow(row) {
        this.isShowDetail = true
        this.row = row
      },
      confirm(action, done) {
        this.isShowDetail = false
        done()
      }
    }
  }
  </script>

  <style  lang='scss'>
  .poputHeader {
    margin-top: 25px;
    display: flex;
    padding: 0 16px;
    justify-content: space-between;
    h2 {

      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 500;
    }
    h3 {

      font-size: 16px;
      color: #208fff;
      letter-spacing: 0;
      font-weight: 500;
    }
    div {
      display: flex;
      h2 {
        position: relative;
        &::after {
          content: "";
          width: 17px;
          height: 2px;
          position: absolute;
          bottom: -4px;
          background: #208fff;
          left: 36%;
          display: none;
        }
      }
    }
    .fontColor {
      color: #208fff;

      &::after {
        display: block !important;
      }
    }
  }
  .poputBody_1 {
    .van-picker__toolbar {
      display: none !important;
    }
    padding-top: 26px;
  }
  .poputBody_2 {
    padding: 0 15px;
    padding-top: 26px;
    > p {

      margin: 0;
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
    }
    .poputBody_2_h {
      div {
        display: flex;
        justify-content: start;
        h1 {

          font-size: 14px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          padding: 5px 16px;
          background: #f8f8f8;
          border: 1px solid rgba(218, 218, 218, 1);
          border-radius: 6px;
          margin-right: 20px;
        }
      }
      .selected {
        border: 1px solid rgba(32, 143, 255, 1);
        color: #464a4c;
      }
      p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        input {
          height: 30px;
          line-height: 30px;
          background: #f8f8f8;
          border: 1px solid rgba(218, 218, 218, 1);
          border-radius: 6px;

          font-size: 14px;
          color: #cccccc;
          letter-spacing: 0;
          font-weight: 400;
          width: 45%;
          text-align: center;
        }
        input:focus {
          background: #f8f8f8;
          border: 1px solid rgba(32, 143, 255, 1);
          color: #464a4c;
        }
        span {
          width: 20px;
          height: 1px;
          display: block;
          background: #cccccc;
        }
      }
    }
    .poputBody_2_h_t {

      font-size: 16px;
      color: #888888;
      letter-spacing: 0;
      font-weight: 400;
      margin-bottom: 20px;
    }
    .poputBody_2_h_b {
      // margin-top: 20px;
          position: relative;
          top: -60px;
      .van-picker__toolbar {
        display: none !important;
      }
      .van-picker__columns {
        height: 230px !important;
      }
      .van-picker__frame {
        top: 55% !important;
      }
      .van-picker-column__item--selected {
        font-weight: 500;
        color: #000;
      }
    }
  }
  .parkingDetailBox_body {
    background: #fbfbfb;
    .parkingDetailBox_body_t {
      height: 70px;
      background: #f1f1f1;
      padding: 0 15px;
      h2 {

        font-size: 15px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
        padding-top: 16px;
        margin-bottom: 10px;
      }
      h3 {

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 400;
        span {
          color: #f46c6c;
        }
      }
    }
    .parkingDetailBox_body_b {
      background: #fff;
      height: 70px;
      overflow: hidden;
      > div {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        margin-top: 14px;
        h1 {

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 400;
        }
        h2 {

          font-size: 18px;
          color: #f46c6c;
          letter-spacing: 0;
          text-align: right;
          font-weight: 500;
        }
        h3 {

          font-size: 12px;
          color: #888888;
          letter-spacing: 0;
          font-weight: 400;
        }
        h4 {

          font-size: 12px;
          color: #888888;
          letter-spacing: 0;
          font-weight: 400;
        }
      }
    }
  }
  .loadMore {
    text-align: center;
    margin: 22px 0;

    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    font-weight: 400;
  }
  .parkingDetailBox .van-nav-bar {
    .van-nav-bar__left {
      .van-icon {
        color: #666;
      }
    }
  }
  .parkingDetailBox {
    .van-nav-bar__title {
      font-family: PingFangSC-Semibold;
      font-size: 17px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
    }
    .parkingDetailBox_header {
      h2 {

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 400;
        position: relative;
        span {
          position: absolute;
          top: 23px;
          border-color: #525657 transparent transparent transparent !important;
          opacity: 1 !important;
          border: 5px solid;
          right: -16px;
        }
      }
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      padding-top: 46px;
      background: #fff;
      height: 50px;
      line-height: 50px;
      .van-ellipsis {

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 400;
      }
      .van-dropdown-menu__title::after {
        border-color: transparent transparent #525657 #525657 !important;
        opacity: 1 !important;
      }
      .van-dropdown-menu__title--active::after {
        border: transparent transparent #525657 #525657 !important;
      }
      .van-dropdown-item__option--active {
        .van-cell__title {
          span {
            color: #208fff;
          }
        }
      }
      .van-cell__title {
        span {

          font-size: 14px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 400;
        }
      }
      .van-cell__value {
        i {
          font-weight: 900;
          font-size: 22px;
        }
      }
      .van-dropdown-item__content {
        height: 80% !important;
      }
    }
    .van-dropdown-menu__bar {
      box-shadow: none;
    }

    // }
  }

  .refreshBox1 {
    max-height: calc(100vh - 96px);
    min-height: calc(100vh - 96px);
    // min-height: 76vh;
    overflow-y: scroll;
    // padding-bottom: 64px;
    box-sizing: border-box;
  }
  </style>
